/**
 * ÉPRIS Priority Toggle - High Performance Version
 * Optimiert für minimale Server-Requests (Bundling Strategy)
 */

const PriorityConfig = {
  GIFT_ID: 49521187422551,
  PRIORITY_ID: 50166180086103, // Deine Priority ID
  DRAWER_SECTION: 'cart-drawer', // Der Name deiner Section
  TOTAL_SELECTOR: '[data-hulkapps-cart-total]' // Dein Preis-Element
};

document.addEventListener("DOMContentLoaded", () => {
  PriorityToggle.init();
});

const PriorityToggle = {
  init() {
    this.bindAll();
    this.setupObserver();
  },

  bindAll() {
    this.bind('gift-toggle', PriorityConfig.GIFT_ID);
    this.bind('priority-toggle', PriorityConfig.PRIORITY_ID);
  },

  bind(toggleId, variantId) {
    const toggle = document.getElementById(toggleId);
    
    // Schutz: Nicht doppelt binden
    if (!toggle || toggle.dataset.bound === 'true') return;
    toggle.dataset.bound = 'true';

    // Status Check (nur wenn wir nicht sicher sind)
    if (!toggle.dataset.checkedInit) {
      this.checkInitialState(toggle, variantId);
    }

    // Event Listener
    toggle.addEventListener('change', (e) => this.handleObjChange(e, toggle, variantId));
  },

  async checkInitialState(toggle, variantId) {
    try {
      // Wenn wir den Cart schon irgendwo global haben, nutze ihn, sonst fetch
      const cart = await fetch('/cart.js').then(r => r.json());
      toggle.checked = cart.items.some(i => i.variant_id === variantId);
      toggle.dataset.checkedInit = 'true';
    } catch (e) {}
  },

  async handleObjChange(e, toggle, variantId) {
    // 1. UI sofort sperren & Feedback geben
    toggle.disabled = true;
    document.body.style.cursor = 'wait';
    const isAdding = e.target.checked;

    try {
      if (isAdding) {
        // --- ADD CASE (Optimiert: Parallel) ---
        // Wir fügen hinzu UND holen das HTML im gleichen Call.
        // Parallel holen wir kurz den Preis, da /add.js manchmal den Gesamtpreis nicht liefert.
        
        const [addRes, cartRes] = await Promise.all([
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: PriorityConfig.DRAWER_SECTION // <--- DAS IST DER TRICK
            })
          }),
          fetch('/cart.js') // Für den absolut sicheren Gesamtpreis
        ]);

        const addData = await addRes.json();
        const cartData = await cartRes.json();
        
        // UI Updates mit den Daten aus dem Response
        this.updateUI(addData.sections[PriorityConfig.DRAWER_SECTION], cartData);

      } else {
        // --- REMOVE CASE (Maximum Speed) ---
        // /cart/change.js liefert ALLES zurück: Cart JSON + HTML Sections.
        // Nur 1 Request nötig!
        
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: String(variantId),
            quantity: 0,
            sections: PriorityConfig.DRAWER_SECTION // <--- DAS IST DER TRICK
          })
        });

        const data = await res.json();
        
        // UI Updates direkt mit den Daten aus diesem einen Request
        this.updateUI(data.sections[PriorityConfig.DRAWER_SECTION], data);
      }

    } catch (err) {
      console.error('Toggle Error:', err);
      // Fallback: Wenn was schiefgeht, Toggle zurücksetzen
      toggle.checked = !isAdding;
    } finally {
      toggle.disabled = false;
      document.body.style.cursor = 'default';
    }
  },

  updateUI(html, cartData) {
    // 1. Drawer HTML ersetzen
    if (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('#cart-drawer');
      const currentDrawer = document.querySelector('#cart-drawer');
      
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    }

    // 2. Preis updaten
    const totalElem = document.querySelector(PriorityConfig.TOTAL_SELECTOR);
    if (totalElem && cartData.total_price) {
      totalElem.textContent = (cartData.total_price / 100).toFixed(2).replace('.', ',') + ' €';
    }

    // 3. Shopify Events feuern (für andere Apps)
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
    
    // 4. Progress Bar etc. (Safe check)
    if (typeof window.updateCartProgressBar === 'function') {
      window.updateCartProgressBar(cartData);
    }
  },

  setupObserver() {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;

    // Wir nutzen einen Debounce beim Observer, damit er nicht feuert, während wir gerade selbst das HTML tauschen
    const observer = new MutationObserver((mutations) => {
       // Prüfen ob Toggles da sind, aber noch nicht gebunden
       const giftToggle = document.getElementById('gift-toggle');
       const prioToggle = document.getElementById('priority-toggle');
       
       if ((giftToggle && giftToggle.dataset.bound !== 'true') || 
           (prioToggle && prioToggle.dataset.bound !== 'true')) {
           
           // Kurz warten damit der DOM stabil ist
           requestAnimationFrame(() => this.bindAll());
       }
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }
};